export function NoRateMessage() {
	return (
		<div className={"k-p-6"}>
			<h3 className={"k-text-center k-mb-4"}>
				We&apos;re sorry, but a rate could not be provided.
			</h3>
		</div>
	);
}
